const ServerBackupMenu = [
  {
    icon: "edit",
    key: "ServerBackupRestore",
    name: "Server Sync",
    url: "home/app/Server-Sync",
    description: "",
    productionReady: true,
    disabled: true
  },
];
  
  export { ServerBackupMenu };